<template>
  <div class="form-check" :class="{ 'ts-filter-option-disabled': disabled }">
    <input
      :id="inputId"
      class="form-check-input"
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      @change="onChange"
    />
    <label class="form-check-label d-flex justify-content-between gap-3" :for="inputId">
      <span><slot /></span>
      <span v-if="loading" class="spinner-grow spinner-grow-sm text-secondary" aria-hidden="true"></span>
      <span v-else-if="count !== null" class="ts-filter-count small">{{ formatCount(count) }}</span>
    </label>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { formatCount } from '@/helpers/formatCount';

let uid = 0;

// One filter option: checkbox, label and its result count on the right (v-model = checked).
// Emits 'change' like b-form-checkbox, so filters keep searching on every change.
@Component
export default class TsFilterCheck extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;

  @Prop({ default: null }) readonly count!: number | string | null;

  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  inputId = `ts-filter-check-${uid += 1}`;

  formatCount(count: number | string) {
    return formatCount(Number(count) || 0);
  }

  onChange(event: Event) {
    const { checked } = event.target as HTMLInputElement;
    this.$emit('input', checked);
    this.$emit('change', checked);
  }
}
</script>
